const message = {
  fire: function(
    message,
    type,
    escape,
    translate,
    displayForOverwrite,
    autoClose,
    skipComponentifyConverters,
    enableConverters,
    theme,
    buttonText,
    onButtonClick
  ) {
    type = type || "success";
    if (escape == undefined) {
      escape = true;
    }

    if (translate == undefined) {
      translate = true;
    }

    if (translate) {
      message = i18n.get(message);
    }

    if (this.removeMessagePopup) {
      this.removeMessagePopup();
      $(".message-popup").remove();
      this.removeMessagePopup = false;
    }

    var params = {
      message: message,
      type: type,
      skipComponentifyConverters: skipComponentifyConverters
    };

    if (enableConverters && typeof enableConverters === "object") {
      params.enableConverters = enableConverters;
    }

    if (autoClose != undefined) {
      params.autoClose = autoClose;
    }

    if (buttonText != undefined) {
      params.buttonText = buttonText;
    }

    if (theme != undefined) {
      params.theme = theme;
    }

    // Gallery message popup.
    var messagePopup = document.querySelectorAll(".media-preview-message-popup");
    if (!messagePopup.length) {
      messagePopup = $('<div class="message-popup"></div>').appendTo(document.body);
    }
    params.onButtonClick = onButtonClick;
    this.removeMessagePopup = prc.SystemNotificationPopup(messagePopup[0], params);
  }
};

export default message;
